export const email = /^.+@.+[.]\w+/

// At least 8 characters, use letters AND numbers/special characters
export const password = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[a-zA-Z]).{6,}$/

export const postalCode = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i

export const phone = /^(\+\d{2}|00\d{2}|\d{2})\d{5,15}$/

// Date format DD-MM-YYYY
// Validates: day/month, month range 01-12, year 1900-2099
// Special handling for February: 29-02 only for leap years (divisible by 4)
// Pattern breakdown:
// - Days 01-28 for all months (including Feb)
// - Day 29 for months 01, 03, 05, 07, 08, 10, 11, 12
// - Days 29-30 for months 04, 06, 09, 11
// - Days 29-31 for months 01, 03, 05, 07, 08, 10, 12
// - Day 29 for Feb only in leap years (separate pattern)
export const date =
  /^((0[1-9]|1[0-9]|2[0-8])-(0[1-9]|1[012])|29-0(1|3|5|7|8)|29-1[012]|30-0(1|3-9)|30-1[012]|31-0(1|3|5|7|8)|31-1[02])-(19|[2-9][0-9])\d\d$|^29-02-(19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$/

export default {
  email,
  password,
  postalCode,
  phone,
  date,
}
